const tickets = (wrapperSelector,btnSelector) => {
    const wrapper = document.querySelectorAll(wrapperSelector);

    wrapper.forEach( item => {
        const btns = item.querySelectorAll(btnSelector),
              left = btns[0],
              right = btns[1],
              input = item.querySelector('input');
        let i = input.value;

        right.addEventListener('click', e => {
            e.preventDefault();

            ++i;
            if (i >= 21) {
                i = 0;
            }
            input.value = i;
        });
        left.addEventListener('click', e => {
            e.preventDefault();

            --i;
            if (i < 0) {
                i = 20;
            }
            input.value = i;
        });
    });
};

export default tickets;